import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import messagesReducer from '../slices/messagesSlice';
import commonReducer from '../slices/commonSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    messages: messagesReducer,
    common: commonReducer,
});

export default rootReducer;

